import React from 'react';

export default function CertificationBadges() {
  const badges = [
    {
      src: "https://api.accredible.com/v1/frontend/credential_website_embed_image/badge/111287727?key=7a55ccc21d288798c83bf90f98b2d1175910abcf9755e3bffa139e74e7fbfb22",
      alt: "CIPP Certification Badge",
      title: "Certified Information Privacy Professional"
    },
    {
      src: "https://api.accredible.com/v1/frontend/credential_website_embed_image/badge/111287735?key=84bbd95da3d5f127d3b4baf04f8f29f1062d9561212acb74df8b22bd6d5f13f3",
      alt: "CIPM Certification Badge",
      title: "Certified Information Privacy Manager"
    },
    {
      src: "https://api.accredible.com/v1/frontend/credential_website_embed_image/badge/111287749?key=8153f445ecc6a270d4f446c69edbe851762e3be95c6f8294d8c8736388266807",
      alt: "CIPT Certification Badge",
      title: "Certified Information Privacy Technologist"
    }
  ];

  return (
    <div className="flex justify-center items-center space-x-4 mt-8">
      {badges.map((badge, index) => (
        <div 
          key={index}
          className="relative group"
          title={badge.title}
        >
          <img 
            src={badge.src} 
            alt={badge.alt} 
            className="w-16 h-16 object-contain transition-transform duration-300 group-hover:scale-110"
          />
          <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
            {badge.title}
          </div>
        </div>
      ))}
    </div>
  );
}